<template lang="pug">

  .greetings
    .container
      .row
        .col-12.col-md-11.offset-md-1
          .title--decor(ref="bigTitle")
            h1.title--50 Сделай свой Digital-проект
          h2.title--30.c-pink.text--uppercase(ref="smallTitle") и узнай, как это больно
          .greetings__pic
            img(src='@/assets/img/man/welcome.svg', alt='' ref="image")
            .dots.dots--big
            .dots.dots--small
          p.greetings__text.text--18(ref="text1") Вы только что заняли должность руководителя одного из маркетинговых направлений, а именно диджитал.
          p.greetings__text.text--18(ref="text2") Ваше первое задание — сделать проект. Сроки горят, бюджет греет счет — пора приступать!
          ButtonItem(text="Начать игру!" ref="startButton" v-on:click.native="changePage('question')")

</template>

<script>
  import { mapMutations } from 'vuex';
  import ButtonItem from '@/components/ButtonItem.vue';
  import anime from 'animejs';

  export default {
    name: 'Welcome',
    components: {
      ButtonItem,
    },
    data() {
      return {
        introTl: anime.timeline({ easing: 'easeOutExpo' })
      }
    },
    methods: {
      ...mapMutations([
        'changePage'
      ]),
    },
    mounted() {
      document.onreadystatechange = () => {
        if (document.readyState === "complete") {
          this.introTl.add({
            targets: this.$root.$children[0].$refs.gameBackground,
            translateX: [-75, 0],
            opacity: [0, 1],
            duration: 750
          })
          .add({
            targets: this.$refs.bigTitle,
            translateX: [-30, 0],
            opacity: [0, 1],
            duration: 750,
            offset: '-=500'
          })
          .add({
            targets: this.$refs.smallTitle,
            translateX: [-30, 0],
            opacity: [0, 1],
            duration: 750,
            offset: '-=500'
          })
          .add({
            targets: this.$refs.image,
            translateY: [75, 0],
            opacity: [0, 1],
            duration: 1250,
            offset: '-=300'
          })
          .add({
            targets: this.$refs.text1,
            translateY: [50, 0],
            opacity: [0, 1],
            duration: 750,
            offset: '-=600'
          })
          .add({
            targets: this.$refs.text2,
            translateY: [50, 0],
            opacity: [0, 1],
            duration: 750,
            offset: '-=500'
          })
          .add({
            targets: this.$refs.startButton.$el,
            translateY: [50, 0],
            opacity: [0, 1],
            duration: 750,
            offset: '-=500'
          });
        }
      };
    }
  }
</script>

<style scoped lang="stylus">
.greetings
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  min-height: calc(100vh - 13rem)
  text-align center

  background-size contain
  background-position center center
  background-repeat repeat
  overflow hidden
  @media $mobile
    background-repeat no-repeat
  .container
    position relative
    padding-top: 2rem
    @media $mobile
      padding-top: 3rem
  .offset-md-1
    position static
  &__pic
    position relative
    height: auto
    padding 0 0 2rem
    margin 0 auto
    box-sizing content-box
    @media $tablet
      padding 3rem 0 2rem
      position static
      width 20rem
      /*padding-top 6rem*/
    img
      display block
      width 100%
      max-width: 100px
      margin: auto
      opacity: 0
      @media $tablet
        max-width: 100%
        width: 100%
  &__text
    max-width 52rem
    margin-left auto
    margin-right auto
    text-align left
    opacity: 0
  .title--decor
    width: 100%
    margin-bottom 1.5rem
    @media $mobile
      margin-bottom 2rem
      width: auto
  .title--30,
  .title--decor
    opacity: 0
  .button
    margin-top 2rem
    opacity: 0
    @media $tablet
      margin-top 4rem
  .dots
    z-index: 1
    background-image: url('~@/assets/img/dot.svg')
    background-size: 1.4rem 1.4rem
    background-repeat: repeat
    pointer-events: none
    @media $tablet
      background-size: 2.8rem 2.8rem
  .dots--big,
  .dots--small
    position absolute
  .dots--big
    top 2rem
    left 0
    @media $tablet
      top 3rem
      bottom 3rem
      left -4.5rem
  .dots--small
    top 2rem
    right 0
    @media $tablet
      top 50%
      right -4.5rem
      margin-top -12.4rem
</style>
